import message from 'antd/es/message';

export const errorToString = (error: any) => {
  if (!error) {
    return;
  }

  if (typeof error === 'string') {
    return error;
  }
  if ('error_msg' in error) {
    return error?.error_msg;
  }
  if (error?.message && error instanceof Error) {
    return error.message;
  }
  try {
    // https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
    return JSON.stringify(error, Object.getOwnPropertyNames(error));
  } catch (e) {
    console.error('errorToString error', e);
    return 'Error';
  }
};

export const toastError = (error: any, defaultTip = 'Failed') => {
  message.error(errorToString(error) || defaultTip);
};

export const toastSuccess = (msg: string) => {
  message.success(msg);
};
